import axios from "axios"
import Hjson from "hjson"

export default {
  baseUrl(): string {
    return process.env.VUE_APP_BASE_URL
  },
  wait(ms: number) {
    return new Promise((resolve, reject) => {
      setTimeout(resolve, ms)
    })
  },
  /**
   * Fetches a HJSON or JSON file from the public folder.
   * @param path relative to the public folder with no leading slash. Ex: 'research/research-tree.hjson'
   */
  async fetchHjson(path: string) {
    let response = await axios.get(
      this.baseUrl() + '/' + path,
      { transformResponse: [(data) => { return data }] }) // Return pure data, do not auto-convert to json

    let data = response.data
    let info = Hjson.parse(data)
    return info
  },
  async getInfo(id: string) {
    return await this.fetchHjson(id + '/info.hjson')
  },
  isVideo(url: string) {
    return /\.webm$/i.test(url)
  },
  sample(array: any[]): any {
    return array[Math.floor(Math.random() * array.length)]
  },
  timeToDays(time: number): number {
    return time / 60
  },
  currentDate(time: number): string {
    let day = Math.floor(this.timeToDays(time))
    let timeofday = ((time % 60) / 60 * 24)
    let hour = Math.floor(timeofday)
    let minute = ((timeofday - hour) * 60)
    return `Day ${day}, ${hour.toFixed(0).padStart(2, '0')}:${minute.toFixed(0).padStart(2, '0')}`
  },
  displayTime(time: number): string {
    let day = Math.floor(this.timeToDays(time))
    let timeofday = ((time % 60) / 60 * 24)
    let hour = Math.floor(timeofday)
    let minute = Math.floor((timeofday - hour) * 60)

    let s = ""
    if (day == 1) s += `${day} day`
    if (day > 1) s += `${day} days`
    if (day >= 1 && hour > 0) s += ", "
    if (hour == 1) s += `${hour} hour`
    if (hour > 1) s += `${hour} hours`
    if (day == 0 && hour == 0) s = `${minute} minutes`
    return s
  },
  uuid(): string {
    return ("" + 1e7 + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (Number(c) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> Number(c) / 4).toString(16)
    )
  },
  capitalize(s: string): string {
    return s.charAt(0).toUpperCase() + s.substr(1)
  },
  pickFrom<E>(list: E[], fraction: number): E {
    let index = this.clamp(Math.round(fraction * (list.length - 1)), 0, list.length - 1)
    return list[index]
  },
  clamp(value: number, min: number, max: number) {
    return Math.max(Math.min(value, max), min)
  },
  /**
   *
   * @param value the number that should be formatted
   * @param relative this number determines how the value should be formatted. If not given, value is used for this.
   */
  showNumber(value: number, relative: number | undefined = undefined): string {
    if (relative == undefined) relative = value

    if (relative < 2) return value.toFixed(2)
    else if (relative < 10) return value.toFixed(1)
    return value.toFixed(0)
  },
  /** Ensure that a value is one of the possible values, if not, will return the first possible value as default. */
  ensure(value: any, possibilities: any[]): any {
    if (possibilities.find(v => v == value)) {
      return value
    }
    return possibilities[0]
  },
  download(filename: string, text: string) {
    let element = document.createElement('a')
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
    element.setAttribute('download', filename)

    element.style.display = 'none'
    document.body.appendChild(element)

    element.click()

    document.body.removeChild(element)
  }
}
